import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ThemeService {
  private _currentTheme = new Subject<any>();
  isTheme = this._currentTheme.asObservable();

  setTheme(isTheme: any): void {
    this._currentTheme.next(isTheme);
  }
}